import React from 'react';
import { Link } from "react-router-dom";
import * as Images from '../../../assets';

const ContactUsAppLink = () => {
  return (
    <>
    <section id='contact1'>
 {/* <div class="bg-gray-100 flex items-center justify-center min-h-screen"> */}
        <div class="container mx-auto px-4 py-8 flex flex-col md:flex-row items-center justify-between">
          <div class="text-center md:text-left md:w-1/2">
            <h1 class="text-5xl font-bold mb-4">
            The Only Apartment App You’ll Ever Need!
            </h1>
            {/* <p class="text-xl mb-4">
              Join {" "}
              <span class="text-purple-600 font-bold">
                13,00,000+
              </span>
              {" "} Apartment &amp; Villa Owners/Residents who use Chokidar globally!
            </p> */}
            <p class="text-xl mt-32 mb-8 text-center">
              Download the {" "}
              <span class="text-blue-600 font-bold">
                Smart Chokidar
              </span>
              {" "} App
            </p>
            <div class="flex justify-center items-center space-x-4">
              {/* <Link to="/">
                <img alt="Download on Google Play" class="h-12" height="50" src={Images.play_store_btn} width="150" />
              </Link> */}
              <Link to="https://apps.apple.com/us/app/smart-chokidar/id6739560477">
                <img alt="Download on the App Store" class="h-12" height="50" src={Images.app_store_btn} width="150" />
              </Link>
            </div>
          </div>
          <div class="mt-8 md:mt-0 md:w-1/2 flex justify-center">
            <img alt="App Screenshots" class="max-w-full h-auto" src={Images.contact_us_img} />
          </div>
        </div>
 {/* </div> */}
    </section>
    </>
  )
}

export default ContactUsAppLink